import { Signal } from "@lit-labs/signals";
import type { AnalyticsResult } from "api-contracts/rpc/analytics";
import type { IAnalyticsDataState } from "./types";

export class AnalyticsDataState implements IAnalyticsDataState {
  readonly data = new Signal.State<AnalyticsResult | null>(null);
  readonly loading = new Signal.State<boolean>(false);
}
